import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { InteriorDesignLibraryService } from '../../entities/interior-design-library.service';
import { AccordionFormComponent } from '../../shared/accordion-form/accordion-form.component';
import {
  InteriorDesignGalleryImageVM,
  InteriorDesignLibrarySet,
  InteriorEnvironmentAndCameraAngleVMs,
  InteriorOrderAccordionContentTypes
} from '../../shared/interior-design-gallery/interior-design-gallery-image-vm';
import { InteriorDesignGalleryComponent } from '../../shared/interior-design-gallery/interior-design-gallery.component';
import { Lookup } from '../../shared/lookup';
import { ToastComponent } from '../../shared/toast/toast.component';
import { ToastService } from '../../shared/toast/toast.service';

@Component({
  selector: 'interior-design-tool',
  standalone: true,
  imports: [AccordionFormComponent, InteriorDesignGalleryComponent, ToastComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './interior-design-tool.component.html',
  styleUrls: ['./interior-design-tool.component.scss', '../../base/base.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class InteriorDesignToolComponent implements OnInit {
  private interiorDesignLibraryService = inject(InteriorDesignLibraryService);
  private toast = inject(ToastService);

  globalInteriorDesigns: InteriorDesignGalleryImageVM[] = [];
  interiorOrderAccordionContentTypes = InteriorOrderAccordionContentTypes;
  angleAndEnvImages: InteriorEnvironmentAndCameraAngleVMs =
    new InteriorEnvironmentAndCameraAngleVMs();

  async ngOnInit() {
    try {
      this.toast.showLoading();
      const designSets = await this.interiorDesignLibraryService.getInteriorDesignsByClientId(
        Lookup.ClientIds.MediaLab,
        true
      );
      const designSetsVM = new InteriorDesignLibrarySet(
        designSets,
        Lookup.ApiStageFsProductDataEndpoint
      );
      if (designSetsVM.GlobalDesigns) {
        this.globalInteriorDesigns = designSetsVM.GlobalDesigns;
      }

      if (this.globalInteriorDesigns.length) {
        this.toast.hideLoading();
      } else {
        this.toast.showError(
          'Error',
          'Sorry, we are unable to load the interior design sets at this time.'
        );
      }
    } catch (err) {
      console.error(err);
      this.toast.showError(
        'Error',
        'Sorry, we are unable to load the interior design sets at this time.'
      );
    }
  }
}
